export default "__VITE_ASSET__283e5864__"